import { Nb_SearchFiltersProps } from "../type/searchFilters.type";
import { ListView } from "./list.view";
import { useRef, useState } from "react";
import useClickOutside from "../../contexMenu/hooks/clickOutside";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { useStyles } from "../style/style";
import { FiltersView } from "./filters.view";
import Backspace from "@mui/icons-material/Backspace";

export const SearchFiltersView = (props: Partial<Nb_SearchFiltersProps>) => {
  const { hideListFn = () => {} } = props;
  const { searchText = () => {} } = props;
  const [searchValue, setSearchValue] = useState("");
  const { classes } = useStyles();
  const containerRef = useRef<HTMLDivElement | null>(null);
  useClickOutside(containerRef, () => props.setIsHidden?.(true));

  const handleClearSearch = () => {
    setSearchValue("");
    props.setInputValue?.("");
    hideListFn(true);
  };

  return (
    <section
      style={{
        // width: "fit-content",
        display: "flex",
        gap: "7px",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ width: "350px", height: "36px", marginTop: "-18px" }}>
        <TextField
          id="search-input"
          size={"small"}
          placeholder={"Search"}
          fullWidth={true}
          value={searchValue}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              props.setInputValue?.((e.target as HTMLInputElement).value);
              searchText();
            }
          }}
          onBlur={(e) => {
            props.setInputValue?.(e.target.value);
          }}
          onChange={(e) => {
            hideListFn(true);
            setSearchValue(e.target.value);
          }}
          onClick={() => {
            hideListFn(false);
          }}
          sx={{
            "& .MuiInputBase-root": {
              paddingLeft: "10px",
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment:
              searchValue && searchValue.length > 0 ? (
                <Backspace
                  onClick={handleClearSearch}
                  style={{
                    color: "rgb(251, 167, 48)",
                    cursor: "pointer",
                    flexShrink: 0,
                  }}
                />
              ) : null,
          }}
          variant="outlined"
          style={{
            height: "36px",
          }}
        />

        <div ref={containerRef}>
          <ListView {...props} />
        </div>
      </div>
      <Button
        variant="contained"
        onClick={() => {
          searchText();
        }}
        className={classes.buttonSearch}
      >
        Search
      </Button>

      {props?.isHiddenFilters ? (
        ""
      ) : (
        <Button
          onClick={props.hiddenFilters}
          variant="contained"
          className={classes.buttonFilters}
        >
          <FilterAltIcon sx={{ color: " #0076FF" }} />
        </Button>
      )}

      <FiltersView {...props} />
    </section>
  );
};
